import React from "react";
import { useUser } from "../Context/UserContext";
import WGVFormContainer from "./WGVFormContainer";
import KNTFormContainer from "./KNTFormContainer";
const FormContainer = (props) => {
    const { user, form } = useUser();
    if (form === "WGV") {
        return React.createElement(WGVFormContainer, Object.assign({}, props));
    }
    if (form === "KNT") {
        return React.createElement(KNTFormContainer, Object.assign({}, props));
    }
    return (React.createElement("p", null,
        "Main container ",
        form,
        ", ", user === null || user === void 0 ? void 0 :
        user.id));
};
export default FormContainer;
